import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { withFirebase } from "../../components/Firebase/Firebase";
import Loading from "../../components/Loading/Loading";
import CompetitionEdit from "../../components/CompetitionEdit/CompetitionEdit";

class AdminCompetitionEdit extends Component {
  componentDidMount() {
    if (this.props.competitionId) {
      // If we already have a competition, lets fetch it
      this.props.methods.getCompetition(this.props.competitionId);
    }
  }

  render() {
    if (
      this.props.competitionId &&
      !this.props.competitions[this.props.competitionId]
    ) {
      // If we are editing an existing competition but don't yet have the data, return a loading spinner

      return (
        <PageWrapper admin context="loading">
          <Loading />
        </PageWrapper>
      );
    }
    return (
      <PageWrapper admin context="competition-edit">
        <CompetitionEdit id={this.props.competitionId} />
      </PageWrapper>
    );
  }
}

export default withRouter(withFirebase(AdminCompetitionEdit));



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminCompetitionEdit.js